import type { LocationDetail, LocationDetailMeta } from "./location.type";
import type { UseGetOptions } from "@/hooks/queries";

import { useGet } from "@/hooks/queries";

export const useGetLocation = (
  locationId?: string | number,
  options?: UseGetOptions<LocationDetail, LocationDetailMeta>
) => {
  const { data, meta, ...queryResult } = useGet<
    LocationDetail,
    LocationDetailMeta
  >("locations", locationId, options);

  return {
    location: data,
    context: meta?.context,
    ...queryResult,
  };
};
